    $('.multiple-items').slick({ 
      dots:true,     
      arrows:false,      
      infinite: true,          
      slidesToShow: 1,
      slidesToScroll: 1
    });
    